import { render, staticRenderFns } from "./GuppyLocationMessage.vue?vue&type=template&id=28520824&"
import script from "./GuppyLocationMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyLocationMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyLocationMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports